<template>
    <div class="pay-take-order-page">
        <div class="page-wrap">
            <div class="page-title">
                <span  class="text1 backIcon"  @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
                <span class="text1">生产加工</span> 
                <i class="el-icon-arrow-right arrow-right"></i>
                <span class="text2">接单支付</span> 
            </div>
            <div class="page-sub-title">支付中心</div>
            <div class="main-wrap">
                <el-row>
                    <el-col :span="4">
                        <span class="c-font black">订单编号</span>
                    </el-col>
                    <el-col :span="18">
                        <span class="c-font black">{{orderNumber}}</span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 40px">
                    <el-col :span="4">
                        <span class="c-font black">支付金额</span>
                    </el-col>
                    <el-col :span="18">
                        <div class="pay-box">
                            <p><span class="c-font blue">订单总金额的{{feeRate}}%</span></p>
                            <p class="pay-text">￥<strong class="strong">{{needPay}}</strong></p>
                            <p><span class="c-font blue">订单总金额 ￥{{totalPrice}}</span></p>
                        </div>
                        <div>
                            <span class="c-font size-12 deep-grey">{{payTip1}}</span>
                        </div>
                        <div>
                            <span class="c-font size-12 deep-grey">{{payTip2}}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 40px">
                    <el-col :span="4">
                        <span class="c-font black">支付方式</span>
                    </el-col>
                    <el-col :span="18">
                        <div class="pay-type-wrap">
                            <el-button @click="submitPay('alipay')"><i class="ic ic-alipay"></i>支付宝支付</el-button>
                            <el-button @click="submitPay('wechat')"><i class="ic ic-wechat"></i>微信支付</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <el-dialog
            title="请使用手机支付宝扫码支付"
            :visible.sync="alipayQrVisible"
            :close-on-click-modal="false"
            width="400px"
        >
            <div style="text-align: center" @click="submitAlipay" title="点击可刷新支付二维码">
                <vue-qr :text="alipayQrText" :size="300"></vue-qr>
            </div>
        </el-dialog>
        
        <el-dialog
            title="请使用手机微信扫码支付"
            :visible.sync="wechatQrVisible"
            :close-on-click-modal="false"
            width="400px"
        >
            <div style="text-align: center" @click="submitWepay" title="点击可刷新支付二维码">
                <vue-qr :text="wechatPayQrText" :size="300"></vue-qr>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import api from '@/api/index.js'
    import request from '@/utils/request'
    import axios from 'axios'
    import md5 from 'md5'
    import vueQr from 'vue-qr'

    export default {
        components: {
            vueQr
        },
        data() {
            return {
                totalPrice: '',
                orderNumber: '',
                addressId: '',
                orderName: '',
                feeRate: '',
                payTip1: '',
                payTip2: '',
                needPay: '',

                checkPayTimer: null,

                wechatQrVisible: false,
                wechatPayQrText: '',

                alipayQrVisible: false,
                alipayQrText: '',
            }
        },
        watch: {

        },
        computed: {
            ...mapGetters([
                'userId'
            ])
        },
        created() {
            this.getQueryData()
            this.getConfig()
            // this.checkIsPay()
        },
        mounted() {
            this.setBodyBgColor('mounted')
        },
        beforeDestroy() {
            clearInterval(this.checkPayTimer)
            this.setBodyBgColor('beforeDestroy')
        },
        methods: {
            // 设置body背景色
            setBodyBgColor(sign) {
                if (sign === 'mounted') {
                    document.querySelector('body').setAttribute('style', 'background-color: #fff')
                    return;
                }
                if (sign === 'beforeDestroy') {
                    document.querySelector('body').removeAttribute('style')
                    return;
                }
            },
            getQueryData() {
                this.totalPrice = this.$route.query.totalPrice
                this.orderNumber = this.$route.query.orderNumber
                this.addressId = this.$route.query.addressId
                this.orderName = this.$route.query.orderName
            },
            getConfig() {
				request({
					url: api.getAppConfigInfo,
					data: {
						type: '2',
                    },
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        if (res.data && res.data[0]) {
                            this.feeRate = parseFloat(res.data[0].config_value) * 100
                        }
                        if (res.data && res.data[1]) {
                            this.payTip1 = res.data[1].config_value
                        }
                        if (res.data && res.data[2]) {
                            this.payTip2 = res.data[2].config_value
                        }
                        if (this.totalPrice && !isNaN(this.totalPrice)) {
                            this.needPay = parseFloat(this.totalPrice) * this.feeRate / 100
                            this.needPay = this.needPay.toFixed(2)
                        } else {
                            this.$message.error("订单总金额不正确，请重新接单")
                        }
                    }
                })
            },

            submitPay(type) {
                if (type == 'alipay') {
                    this.submitAlipay()
                }
                if (type == 'wechat') {
                    this.submitWepay()
                }
            },

            submitAlipay() {
                let orderNumber = this.orderNumber
                let summary = "衣加加平台服务费"
                let totalFee =  this.needPay
                let gateway = "101200"  // 101000 - 支付宝 pc  101200 - 支付宝 当面付   101100 - 微信 pc
                let platform = 'pc'
                let sign = md5("gateway=" + gateway +"&summary=" + summary + "&totalFee=" + parseFloat(totalFee).toFixed(2) + "&orderNumber=" + orderNumber + "yishangzhihui.hll.html")
                console.log(sign)

                request({
                    url: api.pcPayUrl,
                    data: {
                        orderNumber,
                        summary,
                        totalFee,
                        gateway,
                        platform,
                        sign,
                        userId: this.userId
                    },
                    loading: true
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.alipayQrText = res.data
                        this.alipayQrVisible = true
                        this.checkIsPay()
                    } else {
                        this.$message.error(res.errorMsg || '请求支付失败')
                    }
                })
            },

            submitWepay() {
                let orderNumber = this.orderNumber
                let summary = "衣加加平台服务费"
                let totalFee =  this.needPay
                let gateway = "101100"  // 101000 - 支付宝 pc    101100 - 微信 pc
                let platform = 'pc'
                let sign = md5("gateway=" + gateway +"&summary=" + summary + "&totalFee=" + parseFloat(totalFee).toFixed(2) + "&orderNumber=" + orderNumber + "yishangzhihui.hll.html")
                console.log(sign)

                request({
                    url: api.pcPayUrl,
                    data: {
                        orderNumber,
                        summary,
                        totalFee,
                        gateway,
                        platform,
                        sign,
                        userId: this.userId
                    },
                    loading: true
                }).then(res => {
                    // console.log(res)
                    if (res.errorCode == 200) {
                        this.wechatPayQrText = res.data
                        this.wechatQrVisible = true
                        this.checkIsPay()
                    } else {
                        this.$message.error(res.errorMsg || '请求支付失败')
                    }
                    
                })
            },

            checkIsPay() {
                clearInterval(this.checkPayTimer)
                this.checkPayTimer = setInterval(() => {
                    axios.get(api.isPay + '?orderNumber=' + this.orderNumber + '&userId=' + this.userId).then(response => {
                        let res = response.data
                        // console.log(res)
                        if (res.errorCode == 200) {
                            if (res.data == 'y') {
                                this.$message.success('支付成功')
                                clearInterval(this.checkPayTimer)
                                this.alipayQrVisible = false
                                this.wechatQrVisible = false
                                this.$alert('前往订单中心页面进行查看', '支付成功', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        this.$router.replace('/order')
                                    }
                                });
                                
                            } else if (res.data == 'n') {
                                // console.log('未支付')
                            }
                        } else if (res.errorCode = -10200) {
                            this.$message.error(res.errorMsg || '订单不存在')
                            clearInterval(this.checkPayTimer)
                            this.alipayQrVisible = false
                            this.wechatQrVisible = false
                            this.$alert('前往接单列表页重新接单', '订单不存在或出现异常', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.$router.replace('/list-take-order')
                                }
                            });
                        }
                    })
                }, 2000)
                
            }
            
        }
    }
</script>

<style scoped="scoped" lang="scss">
    .pay-take-order-page {

        /* 公共 font-size */
        .c-font {
            font-size: 14px;
            line-height: 22px;
            &.size-12 {
                font-size: 12px;
            }
            &.grey {
                color: rgba(0, 0, 0, 0.45);
            }
            &.deep-grey {
                color: rgba(0, 0, 0, 0.65);
            }
            &.black {
                color: rgba(0, 0, 0, 0.85);
            }
            &.red {
                color: #FF4D4F;
            }
            &.blue {
                color: #3F33FF;
            }
            &.mgt-8 {
                margin-top: 8px;
            }
            &.mgt-4 {
                margin-top: 4px;
            }
            &.mgr-8 {
                margin-right: 8px;
            }
        }
        .page-wrap {
            width: 1184px;
            margin: 0 auto;
        }
        .page-sub-title {
            height: 28px;
            font-size: 20px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 28px;
            margin-bottom: 24px;
        }

        .main-wrap {
            padding: 24px;
            background: #FFFFFF;
            border-radius: 2px;
            border: 1px solid rgba(0, 0, 0, 0.06);
            position: relative;
            .pay-box {
                display: inline-block;
                margin-bottom: 16px;
                padding: 20px 90px;
                text-align: center;
                border-radius: 4px;
                border: 1px solid #3F33FF;
                .pay-text {
                    line-height: 66px;
                    font-size: 20px;
                    color: #3F33FF;
                    .strong {
                        font-size: 46px;
                        font-weight: normal;
                    }
                }
            }
            .pay-type-wrap {
                width: 763px;
                padding: 24px;
                box-sizing: border-box;
                background: #F6F7F9;
                .ic {
                    display: inline-block;
                    width: 24px;
                    height: 24px;
                    background-repeat: no-repeat;
                    background-size: cover;
                    vertical-align: middle;
                    margin-right: 16px;
                }
                .ic-alipay {
                    background-image: url(../../assets/icons/icon_alipay.png);
                }
                .ic-wechat {
                    background-image: url(../../assets/icons/icon_wechat.png);
                }
            }
        }
    }
    
</style>
